<div class="modal-auth-broker-login">
  <!-- <div mat-dialog-title>
    <div class="icon">
      <mat-icon svgIcon="ico-warning-octagon"></mat-icon>
    </div>
    <div class="title">Ops! Algo deu errado.</div>
  </div> -->
  <div mat-dialog-content>
    <!-- <div class="sub-title">{{ subTitle }}</div> -->
    <div class="error-screen">
      <mat-icon svgIcon="session"></mat-icon>
      <div class="text-container">
        <span class="title">Sua sessão será encerrada...</span>
        <span class="subtitle">{{ subTitle }}</span>
        <button (click)='logout()' mat-raised-button color="primary02" class="sm">Efetuar login</button>
      </div>
    </div>
    <!-- <div class="form">
      <div id="snack-bar-msg" class="snack-bar-msg">
        <div #snackBar></div>
      </div>
      <form name="form" (ngSubmit)="loginForm.form.valid" #loginForm="ngForm" novalidate>
        <div [hidden]="!showDoubleAuthetication">
          <mat-form-field class="userinput">
            <mat-icon svgIcon="user" matPrefix></mat-icon>
            <input type="password" (keyup)="resetValidity($event)" matInput placeholder="Resposta"
              autocomplete="questionResp" name="questionResp" [(ngModel)]="questionActive.questionResp"
              #questionResp="ngModel" required minlength="2" maxlength="255" autofocus>
            <mat-icon *ngIf="questionResp.touched && questionResp.valid" matSuffix class="valid">done</mat-icon>
            <mat-icon *ngIf="questionResp.touched && questionResp.invalid" matSuffix class="invalid">clear
            </mat-icon>
            <mat-error
              *ngIf="(questionResp.touched || questionResp.invalid) && (questionResp.value == '' || questionResp.value == null || questionResp.value == undefined)">
              Campo obrigatório</mat-error>
          </mat-form-field>
        </div>
        <div [hidden]="showDoubleAuthetication">
          <div class="col-12">
            <mat-form-field class="userinput">
              <mat-icon svgIcon="user" matPrefix></mat-icon>
              <input (keyup)="resetValidity($event)" matInput placeholder="usuário" autocomplete="username"
                name="username" [(ngModel)]="model.username" #username="ngModel" required minlength="3" maxlength="255">
              <mat-icon *ngIf="username.touched && username.valid" matSuffix class="valid">done</mat-icon>
              <mat-icon *ngIf="username.touched && username.invalid" matSuffix class="invalid">clear</mat-icon>
              <mat-error
                *ngIf="(username.touched || username.invalid) && (username.value == '' || username.value == null || username.value == undefined)">
                Campo obrigatório</mat-error>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="userinput login-user-input ">
              <mat-icon matPrefix class="md-18" svgIcon="login-lock"></mat-icon>
              <input (keyup)="resetValidity($event)" [type]="showpassword ? 'text' : 'password'" matInput
                placeholder="digite sua senha" autocomplete="new-password" name="password" [(ngModel)]="model.password"
                #password="ngModel" required minlength="0" maxlength="255">
              <span *ngIf="model.password && model.password != ''" (click)="togglePassword()" class="showHideSuffix"
                matSuffix>{{showpassword ? 'ocultar': 'mostrar'}}</span>
              <mat-error
                *ngIf="(password.value == '' || password.value == null || password.value == undefined) && (password.touched || password.invalid)">
                Campo obrigatório</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="button-progress">
          <div id="spinnerDiv" *ngIf="!isUserLogged && loading" [ngClass]="{ 'fadeIn': loading, 'fadeOut': !loading }"
            class="animated">
            <mat-spinner diameter="38" color="primary02"></mat-spinner>
          </div>
          <button *ngIf="!showDoubleAuthetication" [ngClass]="{ 'fadeIn': !loading, 'fadeOut': loading, 'error': loginForm.form.invalid && loginForm.touched && username.invalid && password.invalid,
                           'success': !loading && isUserLogged }" mat-raised-button color="primary01" class="animated"
            type="submit" [disabled]="isRequest" (click)="login()">
            Entrar <mat-icon matSuffix>arrow_forward</mat-icon>
          </button>
          <button *ngIf="showDoubleAuthetication" [ngClass]="{ 'fadeIn': !loading, 'fadeOut': loading, 'error': loginForm.form.invalid && loginForm.touched && username.invalid && password.invalid,
                           'success': !loading && isUserLogged }" mat-raised-button color="primary01" class="animated"
            type="submit" [disabled]="isRequest" (click)="respDoubleAuth()">
            Enviar <mat-icon matSuffix>arrow_forward</mat-icon>
          </button>
        </div>
      </form>
    </div> -->
  </div>
</div>